import { useMutation, useQueryClient } from '@tanstack/react-query'
import { meetingKeys } from '@/entities/meeting'
import { ApiError, apiPatchVoid } from '@/shared/api'
import { toast } from '@/shared/ui/toast'

// Пометка «видно заказчику». Право — у того, кто вправе править встречу
// (организатор / админ), считает бэк. Инварианты (приватную нельзя, встречу без
// компании нельзя) UI объясняет заранее, но арбитр — 422 бэка: его текст
// показываем как есть, он конкретнее любого нашего.
export function useSetCustomerVisibility(meetingId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (visible: boolean) =>
      apiPatchVoid(`/meetings/${meetingId}/customer-visibility`, { visible }),
    onSuccess: (_data, visible) => {
      toast.success(
        visible
          ? 'Встреча открыта клиенту — он видит её, запись и расшифровку'
          : 'Встреча закрыта от клиента',
      )
      void qc.invalidateQueries({ queryKey: meetingKeys.detail(meetingId) })
      void qc.invalidateQueries({ queryKey: meetingKeys.lists() })
    },
    onError: (err) => {
      if (err instanceof ApiError && err.status === 422) {
        toast.error(err.message)
        return
      }
      toast.error('Не удалось изменить видимость для заказчика')
    },
  })
}
